import { useMutation } from "react-query";
import { axiosPost } from "../../lib/axiosClient";

const useDeleteChapter = () => {
  return useMutation((chapterId) => {
    return axiosPost("/api/cw/deleteChapter", chapterId);
  });
};

export default useDeleteChapter;
